module.exports = __webpack_public_path__ + "static/media/Roboto-Italic.a720f17a.ttf";